import { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom";
import logo from '../assets/images/logo-pq.png';
import logoFiorentine from '../assets/images/logo_fiorentine.png';
import collectionsJson from "../data/collections.json"
import { Collection } from "../pages/home.page";


export function Navbar() {
    const [showSidebar, setShowSidebar] = useState(false);
    const location = useLocation();

    console.log()
    useEffect(() => {
        setShowSidebar(false);
    }, [location])
    
    return (
        <>
        <div className="container-fluid pq-navbar">
            <header className="d-flex align-items-center justify-content-center justify-content-md-between py-1">
                <div className="col-lg-3 hamburger-menu">
                    <div onClick={() => setShowSidebar(true)} className="d-inline-flex link-body-emphasis text-decoration-none">
                        <svg width="24" height="24" fill="#222222" viewBox="0 0 24 24"><path fillRule="evenodd" d="M23 16v2H1v-2h22zm0-10v2H1V6h22z"></path></svg>
                    </div>
                </div>
                <div className="nav col-12 col-lg-auto mb-2 justify-content-center mb-md-0">
                    {
                        (location.pathname === "/collection/Le%20Fiorentine") ? (
                            <Link to="/"><img src={logoFiorentine} style={{height: "70px"}} alt="paolaquadretti.it" /></Link>
                        ) : (
                            <Link to="/"><img src={logo} style={{height: "70px"}} alt="paolaquadretti.it" /></Link>
                        )
                    }
                    
                </div>
                <div className="col-lg-3 text-end px-4 d-none d-lg-block">
                    <div className="">
                        <span className="px-2 me-2"><Link to="/trunkshows">TRUNK SHOWS</Link></span>
                        <span className="px-2"><Link to="/about">ABOUT US</Link></span>
                    </div>
                </div>
            </header>
        </div>
        <div className={"offcanvas offcanvas-start" + (showSidebar ? " show" : "")} id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
            <ul className="list-group">
                <li className="list-group-item text-end">
                    <button onClick={() => setShowSidebar(false)} type="button" className="btn-close" aria-label="Close"></button>
                </li>
                {
                    (collectionsJson as Collection[]).map((c: Collection) => {
                        if (c.link) {
                            return (
                                <li key={c.shortName} className="list-group-item">
                                    <a className="text-decoration-none text-dark" rel="noreferrer" href={c.link} target="_blank"><h3 className="text-uppercase">{ c.name }</h3></a>
                                </li>
                            )
                        } else {
                            return (
                                <li key={c.shortName} className="list-group-item">
                                    <Link className="text-decoration-none text-dark" to={ "/collection/" + c.shortName }><h3 className="text-uppercase">{c.name}</h3></Link>
                                </li>
                            )
                        }
                    })
                }
                <li className="list-group-item">
                    <Link className="text-decoration-none text-dark" to="/bijoux"><h3 className="text-uppercase">Les Bijoux</h3></Link>
                </li>
                <li className="list-group-item">
                    <Link className="text-decoration-none text-dark" to="/bridal"><h3 className="text-uppercase">Bridal</h3></Link>
                </li>
                <li className="list-group-item">
                    <Link className="text-decoration-none text-dark" to="/celebrities"><h3 className="text-uppercase">Celebrities</h3></Link>
                </li>
                <li className="list-group-item">
                    
                </li>
                <li className="list-group-item"><h3><Link to="/trunkshows">TRUNK SHOWS</Link></h3></li>
                <li className="list-group-item"><h3><Link to="/about">ABOUT US</Link></h3></li>
                <li className="list-group-item"><h3><a target="_blank" rel="noreferrer" href="https://www.instagram.com/paola_quadretti/">INSTAGRAM</a></h3></li>
            </ul>
        </div>
        </>
    )
}